import { Icon, Modal } from '@successmode-ktp/kui';
import styled from 'styled-components';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

function NonCancellableModal({ isOpen, onClose }: Props) {
  return (
    <Modal isOpen={isOpen} hasBackdrop>
      <Modal.Header>
        <Title>
          <Icon.WarningFilled size={28} fillColor='#FF2D55' />
          환급 건 직접 취소 불가
        </Title>
      </Modal.Header>
      <Body>
        해당 건은 환급 비용 처리 청구서에 반영이 완료되어
        <br />
        직접 취소가 불가합니다.
      </Body>
      <Modal.Footer>
        <Modal.Button variant='cancel' onClick={onClose} />
      </Modal.Footer>
    </Modal>
  );
}

const Title = styled.strong`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 12px;
  gap: 8px;
`;

const Body = styled.p`
  width: 440px;
  color: #5f6165;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;

export default NonCancellableModal;
